"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _Input = require("../Input/index");
var _media = require("../../media/index");
var _AutocompleteMultiSelect = require("./AutocompleteMultiSelect");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var AutocompleteMultiSelectInput = function(_param) {
    var _param_clearButtonMode = _param.clearButtonMode, clearButtonMode = _param_clearButtonMode === void 0 ? "has-value" : _param_clearButtonMode, size = _param.size, isDisabled = _param.isDisabled, rest = _object_without_properties(_param, [
        "clearButtonMode",
        "size",
        "isDisabled"
    ]);
    var _useAutocompleteMultiSelectContext = (0, _AutocompleteMultiSelect.useAutocompleteMultiSelectContext)(), reset = _useAutocompleteMultiSelectContext.reset, getInputProps = _useAutocompleteMultiSelectContext.getInputProps, getToggleButtonProps = _useAutocompleteMultiSelectContext.getToggleButtonProps, getDropdownProps = _useAutocompleteMultiSelectContext.getDropdownProps, isOpen = _useAutocompleteMultiSelectContext.isOpen, autocompleteMultiselectSize = _useAutocompleteMultiSelectContext.size, autocompleteMultiSelectDisabled = _useAutocompleteMultiSelectContext.isDisabled;
    var ref = (0, _react.useRef)(null);
    var inputProps = getInputProps(_object_spread({}, getDropdownProps({
        preventKeyAction: isOpen,
        ref: ref
    })));
    var clearButtonConditions = {
        "has-value": inputProps.value,
        never: false,
        always: true
    };
    var shouldShowClearButton = clearButtonConditions[clearButtonMode];
    var inputSize = size !== null && size !== void 0 ? size : autocompleteMultiselectSize;
    var isInputDisabled = isDisabled || autocompleteMultiSelectDisabled;
    var onReset = (0, _react.useCallback)(function() {
        var _reset, _ref_current_focus, _ref_current, _ref;
        (_reset = reset) === null || _reset === void 0 ? void 0 : _reset();
        (_ref = ref) === null || _ref === void 0 ? void 0 : (_ref_current = _ref.current) === null || _ref_current === void 0 ? void 0 : (_ref_current_focus = _ref_current.focus) === null || _ref_current_focus === void 0 ? void 0 : _ref_current_focus.call(_ref_current);
    }, [
        reset
    ]);
    var pointerEventsStyle = isInputDisabled ? {
        pointerEvents: "none"
    } : {};
    var getIcon = function() {
        if (shouldShowClearButton) {
            return _react.default.createElement(_media.IconX, {
                "data-testid": "cmpsr.autocompleteMultiSelect.clear-button",
                cursor: "pointer",
                onClick: onReset,
                style: pointerEventsStyle
            });
        }
        var IconComponent = isOpen ? _media.IconChevronUp : _media.IconChevronDown;
        var testId = isOpen ? "cmpsr.autocompleteMultiSelect.chevron-up" : "cmpsr.autocompleteMultiSelect.chevron-down";
        return _react.default.createElement(IconComponent, _object_spread({
            "data-testid": testId,
            cursor: "pointer"
        }, getToggleButtonProps({
            style: pointerEventsStyle
        })));
    };
    var trailingIcon = getIcon();
    return _react.default.createElement(_Input.Input, _object_spread({
        trailingIcon: trailingIcon,
        size: inputSize,
        isDisabled: isInputDisabled
    }, inputProps, rest));
};
var _default = AutocompleteMultiSelectInput;
